export const metrikaCounterEditorInitialData = {
    isOpen: false,
    markMetrikaLinks: false,
    errors: []
};

export const metrikaCounterEditorInitialValue = {
    counters: undefined,
    markMetrikaLinks: false
};
